import { ArrowRightIcon } from "@radix-ui/react-icons";
import { CSSProperties, FC, ReactNode } from "react";
import { cn } from "../../lib/utils";

interface AnimatedShinyTextProps {
  children: ReactNode;
  className?: string;
  shimmerWidth?: number;
}

interface AnimatedShinyTextDemoProps {}

export const AnimatedShinyTextDemo: FC<AnimatedShinyTextDemoProps> = () => {
  return (
    <div
      className={cn(
        "group rounded-md bg-transparent text-m text-neutral-100 shadow-none hover:scale-105 transition-all ease-in-out"
      )}
      style={{
        padding: "0.4em 1.5rem",
      }}
    >
      <AnimatedShinyText
        shimmerWidth={200}
        className="inline-flex items-center justify-center font-bold transition ease-out hover:text-neutral hover:duration-300"
      >
        <span>🌟 Get Early Access </span>
        <ArrowRightIcon className="ml-3 w-6 h-6 transition-transform duration-300 ease-in-out group-hover:translate-x-2" />
      </AnimatedShinyText>
    </div>
  );
};

export const AnimatedShinyText: FC<AnimatedShinyTextProps> = ({
  children,
  className,
  shimmerWidth = 100,
}) => {
  return (
    <p
      style={
        {
          "--shiny-width": `${shimmerWidth}px`,
        } as CSSProperties
      }
      className={cn(
        "text-3xl text-neutral-200",

        // Shine effect
        "animate-shiny-text bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shiny-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite]",

        // Shine gradient
        "bg-gradient-to-r from-transparent via-neutral-500 via-50% to-transparent",

        className
      )}
    >
      {children}
    </p>
  );
};